import { z, literal, number, object, string, discriminatedUnion } from 'zod';

const baseSchema = object({
  about: z.enum(['clinic', 'doctor']),
  contact: z.enum(['phone', 'email']),
  score: number(),
  text: string().min(1, { message: 'Обязательное поле' }).max(5000, { message: 'Максимум 5000 символов' }),
  author_name: string().min(1, { message: 'Обязательное поле' }),
  publication_consent: literal<boolean>(true, { errorMap: () => ({ message: 'Вы должны согласиться на публикацию отзыва' }) }),
  doctor_id: object({
    id: number(),
  }).optional(),
})
  .superRefine((data, ctx) => {
    if (data.about === 'doctor' && !data.doctor_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Выберите врача',
        path: ['doctor_id'],
      });
    }
  });

const unionContactSchema = discriminatedUnion('contact', [
  object({
    contact: literal('phone'),
    phone: string()
      .min(1, { message: 'Обязательное поле' })
      .min(11, { message: 'Обязательное поле' }),
    email: string().optional(),
  }),
  object({
    contact: literal('email'),
    email: string()
      .min(1, 'Email обязателен')
      .email('Неверный формат email'),
    phone: string().optional(),
  }),
]);

export const createReviewFormSchema = baseSchema.and(unionContactSchema);

export type CreateReviewForm = z.infer<typeof createReviewFormSchema>;
